<div [formGroup]="permissionTemplates" *ngIf="!partnersMode">
	<div class="radio-label" data-test-id="permissions-presets" id="radio-group-label">Permissions presets:</div>
	<mat-radio-group
		[hidden]="cloud === cloudTypes.Azure"
		name="permission-template"
		formControlName="control"
		aria-labelledby="radio-group-label"
	>
		<mat-radio-button id="permissions-presets-readonly" class="mr-2" value="readonly">Read-only</mat-radio-button>
		<mat-radio-button id="permissions-presets-managed" class="mr-2" value="managed">Managed</mat-radio-button>
		<mat-radio-button id="permissions-presets-custom" class="mr-2" value="custom">Custom</mat-radio-button>
	</mat-radio-group>
</div>

<div *ngIf="isLoading" class="loader">
	<app-show-process [process]="processStatus"></app-show-process>
</div>

<div class="permission-tree onbording-tree-wrapper">
	<mat-tree *ngIf="!isLoading" [dataSource]="dataSource" [treeControl]="treeControl">
		<p>
			<b>Configure {{ PRODUCT_LABEL | titlecase }} Solutions</b>
		</p>

		<mat-nested-tree-node *matTreeNodeDef="let node; when: isFirstLevel" matTreeNodePadding>
			<li>
				<button mat-icon-button matTreeNodeToggle [disableRipple]="true">
					<mat-icon class="mat-icon-rtl-mirror">
						{{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
					</mat-icon>
				</button>
				Specify actions allowed in <strong>{{ node.name }}</strong>
				<ul
					[@slideVertical]="{
						value: treeControl.isExpanded(node) ? 'show' : 'hide',
						params: { delay: delayTime }
					}"
					[class.permission-tree-invisible]="!treeControl.isExpanded(node)"
				>
					<ng-container matTreeNodeOutlet></ng-container>
				</ul>
			</li>
		</mat-nested-tree-node>

		<mat-nested-tree-node
			*matTreeNodeDef="let node; when: isPermCategoryLevel"
			matTreeNodePadding
			[class.display-columns]="node.children?.length > 5"
		>
			<li>
				<button mat-icon-button matTreeNodeToggle [disableRipple]="true">
					<mat-icon class="mat-icon-rtl-mirror">
						{{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
					</mat-icon>
				</button>
				<mat-checkbox
					[checked]="descendantsAllSelected(node)"
					[disableRipple]="true"
					[disabled]="isDisabled(node) || isAllChildrenDisabled(node)"
					[indeterminate]="descendantsPartiallySelected(node)"
					(change)="permissionSelectionToggle(node)"
					>{{ node.name | titlecase }}</mat-checkbox
				>
				<ul
					class="permission-tree__list"
					[@slideVertical]="{
						value: treeControl.isExpanded(node) ? 'show' : 'hide',
						params: { delay: delayTime }
					}"
					[class.permission-tree-invisible]="!treeControl.isExpanded(node)"
				>
					<ng-container matTreeNodeOutlet></ng-container>
				</ul>
			</li>
		</mat-nested-tree-node>

		<mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
			<li>
				<button mat-icon-button matTreeNodeToggle [disableRipple]="true">
					<mat-icon class="mat-icon-rtl-mirror">
						{{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
					</mat-icon>
				</button>
				<mat-checkbox
					[checked]="descendantsAllSelected(node)"
					[disabled]="isDisabled(node)"
					[disableRipple]="true"
					[indeterminate]="descendantsPartiallySelected(node)"
					(change)="permissionSelectionToggle(node)"
					>{{ node.name }}</mat-checkbox
				>
				<ul
					[@slideVertical]="{
						value: treeControl.isExpanded(node) ? 'show' : 'hide',
						params: { delay: delayTime }
					}"
					[class.permission-tree-invisible]="!treeControl.isExpanded(node)"
				>
					<ng-container matTreeNodeOutlet></ng-container>
				</ul>
			</li>
		</mat-nested-tree-node>

		<mat-tree-node *matTreeNodeDef="let node" class="permission-level" matTreeNodePadding>
			<mat-checkbox
				class="checklist-leaf-node"
				[disableRipple]="true"
				[disabled]="isDisabled(node)"
				[checked]="checklistSelection.isSelected(node)"
				(change)="leafSelectionToggle(node)"
			>
				<span [class.highlight]="highlightPermission(node.name)">{{ node.name }}</span>
			</mat-checkbox>
		</mat-tree-node>
	</mat-tree>
</div>
